import { motion } from "framer-motion";
import { Reveal, SectionHead } from "@/components/Reveal";
import { GALLERY, imgSrc, imgSrcset } from "@/data/content";

export default function Gallery() {
  return (
    <section id="galerie" className="relative overflow-hidden bg-night-soft py-16 md:py-24 lg:py-32" data-testid="gallery-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHead
          eyebrow="Galerie"
          title="La passion, en images."
          sub="Motos, balades, afterworks et rencontres : la vie du club se vit aussi en dehors des réunions."
        />
        <div className="mt-14 grid grid-cols-2 gap-3 sm:gap-4 md:grid-cols-4" data-testid="gallery-grid">
          {GALLERY.map((g, i) => (
            <motion.figure
              key={i}
              initial={{ opacity: 0, y: 32, scale: 0.97 }}
              whileInView={{ opacity: 1, y: 0, scale: 1 }}
              viewport={{ once: true, amount: 0.15 }}
              transition={{ duration: 0.7, delay: (i % 4) * 0.07, ease: [0.22, 1, 0.36, 1] }}
              className={`group relative overflow-hidden rounded-2xl border border-border ${g.tall ? "row-span-2 h-full min-h-[320px] md:min-h-[420px]" : "h-40 sm:h-48 md:h-52"}`}
              data-testid={`gallery-item-${i + 1}`}
            >
              <img
                src={imgSrc(g.key, 800)}
                srcSet={imgSrcset(g.key)}
                sizes="(min-width: 768px) 25vw, 50vw"
                width={1600}
                height={g.tall ? 2000 : 1067}
                alt={g.alt}
                loading="lazy"
                className="h-full w-full object-cover transition-transform duration-[1.2s] ease-out group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-night/85 via-transparent to-transparent opacity-70 transition-opacity duration-500 group-hover:opacity-100" />
              <span className="absolute inset-0 rounded-2xl border border-transparent transition-colors duration-500 group-hover:border-gold/60" />
              <figcaption className="absolute bottom-0 left-0 right-0 flex items-center justify-between p-4 opacity-0 transition-all duration-500 group-hover:opacity-100">
                <span className="text-xs font-semibold text-white">{g.alt}</span>
                <span className="rounded-full bg-gold/90 px-2.5 py-0.5 text-[10px] font-bold uppercase tracking-wider text-night">{g.cat}</span>
              </figcaption>
            </motion.figure>
          ))}
        </div>
        <p className="mt-8 text-center text-xs text-muted-foreground" data-testid="gallery-placeholder-note">
          Photos d'illustration.
        </p>
      </div>
    </section>
  );
}
